export { ShareNavBarContainer as ShareNavBar } from './ShareNavBar.container';
